// Membresía Torneos123 ($99 al mes por jugador y club) — etapa 3a.
import { apiFetch } from "./api";

export type T123StandingCode =
  | "billing_off"
  | "exempt"
  | "club_pays"
  | "active"
  | "cancelled_active"
  | "grace"
  | "renewal_pending"
  | "unpaid"
  | "no_booking"
  | "suspended"
  | "cancelled";

export interface T123Standing {
  code: T123StandingCode;
  label: string;
  can_book: boolean;
  grace_until: string | null;
}

export interface T123Charge {
  id: number;
  status: string;
  amount: number;
  subtotal: number;
  tax_amount: number;
  currency: string;
  period_start: string | null;
  period_end: string | null;
  created_at: string | null;
}

export interface T123PlayerMembership {
  club_id: number;
  player_profile_id: number;
  billing_enabled: boolean;
  membership_payer: string;
  price: number;
  currency: string;
  standing: T123Standing;
  membership: null | {
    id: number;
    status: string;
    paid_until: string | null;
    next_payment_date: string | null;
    card_last4: string | null;
    card_brand: string | null;
    cancelled_at: string | null;
    init_point: string | null;
    card_change_pending: boolean;
  };
  charges: T123Charge[];
}

export interface T123ClubSummary {
  billing_enabled: boolean;
  membership_payer: string;
  grace_days: number;
  after_grace: string;
  price: number;
  counts: { al_corriente: number; en_gracia: number; sin_pagar: number };
  members: Array<{
    member_id: number;
    player_profile_id: number;
    name: string;
    standing: T123Standing;
    bucket: "al_corriente" | "en_gracia" | "sin_pagar";
  }>;
}

export interface T123Income {
  billing_enabled: boolean;
  mode: string;
  price: number;
  totals: { approved: number; reversed: number; net: number; charges: number; needs_review: number };
  memberships_by_status: Record<string, number>;
  charges: Array<T123Charge & { club_name: string; player_name: string; membership_id: number; status_detail: string | null }>;
}

function profileQuery(playerProfileId?: number | null): string {
  return playerProfileId ? `?player_profile_id=${encodeURIComponent(String(playerProfileId))}` : "";
}

export const t123MembershipApi = {
  player: (token: string, clubId: number, playerProfileId?: number | null) =>
    apiFetch<{ ok: boolean; data: T123PlayerMembership }>(
      `/player/clubs/${clubId}/t123-membership${profileQuery(playerProfileId)}`,
      { token },
    ),
  subscribe: (token: string, clubId: number, playerProfileId?: number | null) =>
    apiFetch<{ ok: boolean; data: { init_point: string; membership_id: number; reused: boolean } }>(
      `/player/clubs/${clubId}/t123-membership/subscribe${profileQuery(playerProfileId)}`,
      { method: "POST", token },
    ),
  cancel: (token: string, membershipId: number) =>
    apiFetch<{ ok: boolean; data: T123PlayerMembership }>(`/player/t123-memberships/${membershipId}/cancel`, {
      method: "POST",
      token,
    }),
  changeCard: (token: string, membershipId: number) =>
    apiFetch<{ ok: boolean; data: { init_point: string } }>(`/player/t123-memberships/${membershipId}/change-card`, {
      method: "POST",
      token,
    }),
  clubSummary: (token: string) =>
    apiFetch<{ ok: boolean; data: T123ClubSummary }>("/club/t123-membership", { token }),
  income: (token: string) =>
    apiFetch<{ ok: boolean; data: T123Income }>("/superadmin/t123-memberships/income", { token }),
};

/** Etiqueta corta del estado del cobro de un renglón. */
export function t123ChargeStatusLabel(status: string): string {
  switch (status) {
    case "approved":
      return "Pagado";
    case "rejected":
      return "Rechazado";
    case "pending":
      return "En proceso";
    case "refunded":
      return "Reembolsado";
    case "charged_back":
      return "Contracargo";
    case "needs_review":
      return "Revisar a mano";
    default:
      return status;
  }
}
